/**
 * Promotion popup behaviour — restrained by design:
 *  - shows ONCE per browsing session, after a configurable delay;
 *  - any dismissal (×, Not now, Escape, CTA) is remembered for the session;
 *  - never interrupts another open dialog (cart drawer, menu, Elli) — it
 *    simply skips that page view and may try again on the next page;
 *  - native <dialog> modal gives focus containment and Escape handling;
 *    the deterministic close path also marks dismissal (the embedded
 *    preview browser never fires `close` — never rely on it alone).
 * No email capture, no urgency, no tracking payloads.
 */
(() => {
  'use strict';
  const popup = document.querySelector('[data-promo-popup]');
  if (!popup) return;

  const KEY = 'me_promo_dismissed';
  let seen = false;
  try {
    seen = sessionStorage.getItem(KEY) === '1';
  } catch {
    /* storage unavailable → show at most this page view */
  }
  if (seen) return;

  const dismiss = () => {
    try {
      sessionStorage.setItem(KEY, '1');
    } catch {
      /* ignore */
    }
    if (popup.open) popup.close();
  };

  popup.querySelector('[data-promo-close]')?.addEventListener('click', dismiss);
  popup.querySelector('[data-promo-dismiss]')?.addEventListener('click', dismiss);
  popup.querySelector('[data-promo-cta]')?.addEventListener('click', () => {
    // Navigating to the collection counts as engaging — don't re-show later.
    try {
      sessionStorage.setItem(KEY, '1');
    } catch {
      /* ignore */
    }
  });
  // Escape → the dialog's cancel event; mark dismissed so it stays away.
  popup.addEventListener('cancel', () => {
    try {
      sessionStorage.setItem(KEY, '1');
    } catch {
      /* ignore */
    }
  });

  const delaySeconds = Number(popup.dataset.delaySeconds);
  const delayMs = Number.isFinite(delaySeconds) && delaySeconds >= 0 ? delaySeconds * 1000 : 6000;

  setTimeout(() => {
    // Restraint: never stack over an open drawer/panel; skip this page view
    // without marking dismissed — a calmer moment can try again.
    if (document.querySelector('dialog[open]')) return;
    let alreadySeen = false;
    try {
      alreadySeen = sessionStorage.getItem(KEY) === '1';
    } catch {
      /* ignore */
    }
    if (alreadySeen || popup.open) return;
    popup.showModal();
  }, delayMs);
})();
